export default function FeatureCard({ icon, title, description }) {
  return (
    <div style={{
      background: 'var(--bg-tertiary)',
      borderRadius: 'var(--radius-lg)',
      padding: 'var(--spacing-xl)',
      border: '1px solid var(--border)',
      transition: 'transform var(--transition-normal), box-shadow var(--transition-normal), border-color var(--transition-normal)',
      cursor: 'pointer'
    }}
    onMouseEnter={(e) => {
      e.target.style.transform = 'translateY(-4px)'
      e.target.style.boxShadow = 'var(--shadow-lg)'
      e.target.style.borderColor = 'var(--accent)'
    }}
    onMouseLeave={(e) => {
      e.target.style.transform = 'translateY(0)'
      e.target.style.boxShadow = 'none'
      e.target.style.borderColor = 'var(--border)'
    }}
    >
      <div style={{
        fontSize: '3rem',
        marginBottom: 'var(--spacing-md)',
        textAlign: 'center'
      }}>
        {icon}
      </div>
      <h3 style={{
        textAlign: 'center',
        marginBottom: 'var(--spacing-md)',
        color: 'var(--text-primary)'
      }}>
        {title}
      </h3>
      <p style={{
        textAlign: 'center',
        color: 'var(--text-secondary)',
        margin: 0
      }}>
        {description}
      </p>
    </div>
  )
} 